import * as React from 'react';
import * as moment from 'moment';
import { flatten, uniq } from 'lodash';

import { connect } from 'react-redux';

import DropdownView from "../../views/controlled-dropdown";
import { IOption, MediaGalleryAppState } from '../../classes/index';
import { Dispatch } from 'redux';
import { IFilter } from '../../classes/filter';
import { applyFilter, removeFilter, removeAllFilters } from '../redux/actions/filters';
import { getFilters } from '../redux/actions/media-api';
import { IMediaGalleryFilterResponse, IMediaGalleryItem } from '../../classes/media-gallery';
import { stringIsNullOrEmpty } from '../../helpers/index';


export interface ExternalProps {
}

export interface StateToProps {
    baseFilters: IMediaGalleryFilterResponse
}

interface DispatchToProps {
    upsertFilter: (filter: IFilter) => any;
    removeFilter: (key: string) => any;
    removeAllFilters: () => any;
    getFilters: () => void;
}

interface MediaGalleryFiltersState {
    selectedItems: string[];
    options: { seasons: { [key: string]: IOption[] }, productions: { [key: string]: IOption[] } };
}

type MediaGalleryFiltersProps = ExternalProps & StateToProps & DispatchToProps;

const _momentFormat = "MMM YYYY";

export class MediaGalleryFilters extends React.Component<MediaGalleryFiltersProps, MediaGalleryFiltersState> {
    constructor(props: MediaGalleryFiltersProps) {
        super(props);

        this.state = {
            selectedItems: ["", ""],
            options: {
                productions: {}, seasons: {}
            }
        };

        props.getFilters();
    }

    /**
     * If new filters get passed in for whatever reason, it will go through this function.
     * @param props
     */
    componentWillReceiveProps(props: MediaGalleryFiltersProps) {
        if (props.baseFilters) {
            // Extract all seasons and productions options from the API call. Prepend with the selection for all.
            let seasons = [{ text: "All", value: "" }].concat(props.baseFilters.seasons.map(it => { return { text: it, value: it } }));
            let productions = [{ text: "All", value: "" }].concat(props.baseFilters.productions.map(it => { return { text: it, value: it } }));

            let seasonOptions = { "": seasons };
            let productionOptions = { "": productions };

            Object.keys(props.baseFilters.seasonToProduction).forEach(key => {
                productionOptions[key] = [{ text: "All", value: "" }].concat(props.baseFilters.seasonToProduction[key].map(prod => { return { text: prod, value: prod } }));
            });

            Object.keys(props.baseFilters.productionToSeason).forEach(key => {
                seasonOptions[key] = [{ text: "All", value: "" }].concat(props.baseFilters.productionToSeason[key].map(season => { return { text: season, value: season } }));
            });

            this.setState({
                selectedItems: ["", ""],
                options: {
                    seasons: seasonOptions,
                    productions: productionOptions
                }
            });
        }
    }

    private generateFilter(key: string, property: keyof IMediaGalleryItem, expectedValue: string): IFilter {
        return {
            key: key,
            func: ((it: IMediaGalleryItem) => {
                return it[property] === expectedValue
            })
        }
    }

    private updateSeasonFilter(evt: React.ChangeEvent<HTMLSelectElement>) {
        const filterValue = evt.currentTarget.value;

        if (stringIsNullOrEmpty(filterValue)) {
            this.props.removeFilter("season");
        } else {
            const filter = this.generateFilter("season", "seasonTag", evt.currentTarget.value);
            this.props.upsertFilter(filter);
        }

        let newArray = [...this.state.selectedItems];
        newArray[0] = filterValue;

        this.setState({
            selectedItems: newArray
        });
    }
    private boundSeasonFilter = this.updateSeasonFilter.bind(this);

    private updateProductionFilter(evt: React.ChangeEvent<HTMLSelectElement>) {
        const filterValue = evt.currentTarget.value;

        if (stringIsNullOrEmpty(filterValue)) {
            this.props.removeFilter("production");
        } else {
            const filter = this.generateFilter("production", "productionName", evt.currentTarget.value);
            this.props.upsertFilter(filter);
        }

        let newArray = [...this.state.selectedItems];
        newArray[1] = filterValue;

        this.setState({
            selectedItems: newArray
        });
    }
    private boundProductionFilter = this.updateProductionFilter.bind(this);

    private getOptionsByKey(key: keyof IMediaGalleryFilterResponse) {
        if (this.state.options[key] && Object.keys(this.state.options[key]).length > 0) {
            let str = "";
            if (key === "seasons") {
                str = this.state.selectedItems[1];
            } else {
                str = this.state.selectedItems[0];
            }
            return this.state.options[key][str.charAt(0).toLowerCase() + str.slice(1)];
        }

        return [];
    }

    clearAll(evt: React.MouseEvent<HTMLButtonElement>) {
        this.props.removeAllFilters();

        this.setState({
            selectedItems: ["", ""]
        });
    }
    private boundClearAll = this.clearAll.bind(this);

    render() {
        return (
            <div className="media-gallery-filters" >
                <DropdownView selectedValue={this.state.selectedItems[0]} options={this.getOptionsByKey("seasons")} label="Season" htmlId="season-dropdown-js" onChange={this.boundSeasonFilter} />
                <DropdownView selectedValue={this.state.selectedItems[1]} options={this.getOptionsByKey("productions")} label="Production" htmlId="production-dropdown-js" onChange={this.boundProductionFilter} />
                <div className="clear-filter">
                    <button className="btn-text" onClick={this.boundClearAll}>Clear Filters</button>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: MediaGalleryAppState): StateToProps {
    return {
        baseFilters: state.mediaApiModel.filters
    }
}

function mapDispatchToProps(dispatch: Dispatch<MediaGalleryAppState>, ownProps: ExternalProps): DispatchToProps {
    return {
        upsertFilter: (filter: IFilter) => dispatch(applyFilter(filter)),
        removeFilter: (key: string) => dispatch(removeFilter(key)),
        getFilters: () => dispatch(getFilters()),
        removeAllFilters: () => dispatch(removeAllFilters())
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(MediaGalleryFilters);


// WEBPACK FOOTER //
// ./app/media-gallery/components/filters.tsx